import React, { useEffect, useState } from 'react';
import { LinkContainer } from 'react-router-bootstrap';

// Styled Components Import
import styled from 'styled-components';

// Bootstrap Imports
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// Firebase Imports
import { storage } from '../../../config/fbConfig';

// Styled Components
const MajoDiv = styled.div`
	background: url('${(props) => props.imageUrl}') no-repeat;
	background-size: contain;
	background-position: right;
	width: 100%;
	height: 550px;
`;

const AboutMe = () => {
	// Component State
	const [imageUrl, setImageUrl] = useState('');

	// Componenet Hooks
	useEffect(() => {
		storage
			.ref('static-web-imgs')
			.child('foto-about-me_1440x810.png')
			.getDownloadURL()
			.then((res) => {
				setImageUrl(res);
			});
	}, []);

	return (
		<Row className='about-me-container d-flex align-items-center mx-0'>
			<Col
				xs={{ span: 12, order: 2 }}
				md={{ span: 7, order: 1 }}
				className='d-flex align-items-center justify-content-center text-center px-4 px-md-5 my-5'
				style={{ minWidth: '50vw', minHeight: 400, backgroundColor: '#fff' }}>
				<div className='about-me-text'>
					<h1>Acerca de mi</h1>
					<p style={{ textAlign: 'justify' }}>
						Soy una vendedora tradicional de las de toda la vida y digital de
						esta nueva era. Una marketera que te ayudará a comunicar lo que te
						interesa comunicar, en el formato que más te convenga y así obtener
						un engagement exitoso.
					</p>
					<p style={{ textAlign: 'justify' }}>
						Una publicista, que diseña, crea, escribe posts, realiza catálogos,
						crea estrategias de marketing y publicitarias, da vida a tus ideas y
						las plasma en la web y en las redes sociales. Que twitea, postea y
						likea por ti; o si quieres te muestra cómo hacerlo, según convenga;{' '}
						<strong>para darte voz.</strong>
					</p>
					<p style={{ textAlign: 'justify' }}>
						Porque sé que tú tienes algo que decirle a tus clientes y ellos
						están tratando de encontrarte, pero no saben dónde. Porque quizás no
						sabes por qué medio comunicarte, sabes que decir, pero no sabes
						cómo, te cuesta, te aburre, no tienes tiempo, o simplemente ya estas
						enfocado en una parte muy importante de tu negocio que demanda tu
						tiempo y esfuerzo.
					</p>
					<p style={{ textAlign: 'justify' }}>
						Pues a partir de hoy cuenta con <strong>Majo Cobos</strong> que lo
						hace por ti.
					</p>
					<div className='mx-auto' style={{ maxWidth: 300 }}>
						<LinkContainer to='#'>
							<div className='action-button full-width mt-4'>Visita mi CV</div>
						</LinkContainer>
					</div>
				</div>
			</Col>
			<Col
				xs={{ span: 12, order: 1 }}
				md={{ span: 5, order: 2 }}
				className='d-flex align-items-center px-0'
				style={{
					minWidth: '30vw',
				}}>
				<MajoDiv imageUrl={imageUrl}>
					<div className='frase-majo d-flex flex-column justify-content-center text-center pl-3'>
						"El mundo está cambiando muy rápido. Ya no será el grande quien
						golpee al pequeño, será el rápido quien golperá al lento."
						<span style={{ fontSize: 12, marginTop: 10 }}>Rupert Murdoch</span>
					</div>
				</MajoDiv>
			</Col>
		</Row>
	);
};

export default AboutMe;
